<template>
    <div class="chaptering-container h-inherit pointer disable-selection">
        <div class="row no-gutters">
            <div class="col-lg-12 text-center bg-sidebar text-white font-weight-bold">
                TIMESHIFT MODE
            </div>

            <SideBarInTimeShiftMode :key="'timeshift-sidebar-lang-' + $i18n.locale"/>

            <div v-for="chapter in chapters" :key="chapter.id" class="one-chapter col-lg-12">
                <!-- Chapter -->
                <div class="row no-gutters" @click="clickOnChapter(chapter)" :class="{'bg-dark text-white': getChaptersToHighlight.includes(chapter.id)}">
                    <!-- Chapter Timpestamp -->
                    <div class="col-lg-3 col-md-4 col-5 pt-2 br text-center timing-header">
                        <h3>{{ $moment().startOf('day').seconds(chapter.timestamp).format('HH:mm:ss') }}</h3>
                    </div>

                    <!-- Chapter Title -->
                    <div class="col-lg-9 col-md-8 col-7">
                        <h3 class="chapter-header">
                            {{ chapter.title }}
                            <!--
                            <span class="badge badge-primary" v-if="(chapter_start_id === chapter.id) && (entry_start_id === null)">
                                Start
                            </span>
                            <span class="badge badge-primary" v-if="(chapter_end_id === chapter.id) && (entry_end_id === null)">
                                End
                            </span>
                            -->
                        </h3>
                    </div>
                </div>

                <!-- Entries -->
                <div class="row no-gutters" v-for="entry in chapter.entries" @click="clickOnEntry(chapter, entry)" :class="getEntryClass(entry)">
                    <!-- Entry Timpestamp -->
                    <div class="col-lg-3 col-md-4 col-5 br text-center timing">
                        <span class="">{{ $moment().startOf('day').seconds(entry.timestamp).format('HH:mm:ss') }}</span>
                    </div>

                    <!-- Entry Title -->
                    <div class="col-lg-9 col-md-8 col-7 chapter-entry-container">
                        <span class="chapter-entry">
                            {{ entry.text }}
                            <!--
                            <span class="badge badge-primary" v-if="(entry_start_id === entry.id)">
                                Start
                            </span>
                            <span class="badge badge-primary" v-if="(entry_end_id === entry.id)">
                                End
                            </span>
                            -->
                        </span>
                    </div>
                </div>
            </div>

        </div>

        <!-- Timeshift Modal -->
        <SweetModal ref="timeshiftModal" :title="$t('UI_INSTANCE_TIMESHIFT_MODAL_TITLE')" :blocking="true" @close="setDefaults">

            <div class="row" v-if="getSecondsOfFirstSelectedElement !== null">
                <div class="col-12 text-center font-weight-bold">
                    <h5>
                        Current Time:<br>
                        <span class="badge badge-dark">
                            {{ secondsToTimestamp(getSecondsOfFirstSelectedElement) }}
                        </span>
                    </h5>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-1">
                    <div class="custom-control custom-radio">
                        <input type="radio" id="addTime" value="subtract" name="customRadio" class="custom-control-input" v-model="mode">
                        <label class="custom-control-label" for="addTime">-</label>
                    </div>
                </div>
                <div class="col-1">
                    <div class="custom-control custom-radio">
                        <input type="radio" id="removeTime" value="addition" name="customRadio" class="custom-control-input" v-model="mode">
                        <label class="custom-control-label" for="removeTime">+</label>
                    </div>
                </div>
                <div class="col-10">
                    <select class="custom-select custom-select-sm" v-model="secondsToAdjust">
                        <option value="0" selected>0h</option>
                        <option value="3600">1h</option>
                        <option value="7200">2h</option>
                        <option value="10800">3h</option>
                        <option value="14400">4h</option>
                        <option value="18000">5h</option>
                    </select>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-12">
                    <hr>
                </div>
                <div class="col-2 text-center">
                    <button class="btn btn-block btn-outline-primary btn-sm" @click="sliderValue--" :disabled="sliderValue <= 0">
                        <i class="fa fa-minus"></i>
                    </button>
                </div>
                <div class="col-8">
                    <vue-slider v-model="sliderValue" :min="0" :max="3600"/>
                </div>
                <div class="col-2 text-center">
                    <button class="btn btn-block btn-outline-primary btn-sm" @click="sliderValue++" :disabled="sliderValue >= 3600">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
                <div class="col-12 mt-2 text-center font-weight-bold">
                    <h5>
                        Time after timeshifting:<br>
                        <span class="badge badge-dark">
                            {{ secondsToTimestamp(getSecondOutcomeForFirstElement) }}
                        </span>
                    </h5>
                </div>
            </div>

            <div slot="button">
                <button class="btn btn-primary" v-if="canLaunchTimeshift" @click="executeTimeshift">{{ $t("UI_MODAL_BUTTON_SAVE") }}</button>
                <button class="btn btn-secondary ml-1"  @click="$refs.timeshiftModal.close()">{{ $t("UI_MODAL_BUTTON_CLOSE") }}</button>
            </div>
        </SweetModal>
    </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';

import VueSlider from 'vue-slider-component';
import SideBarInTimeShiftMode from '../../Sidebar/TimeShiftMode/SideBarInTimeShiftMode';

import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';

import 'vue-slider-component/theme/antd.css';

import Loading from 'vue-loading-overlay';

const ChapterRepository = RepositoryFactory.get('chapters');
const InstanceRepository = RepositoryFactory.get('instances');

export default {
  name: 'ChapterEntryListInTimeShiftMode',
  components: {
    SideBarInTimeShiftMode, Loading, SweetModal, VueSlider,
  },
  props: ['chapters'],
  watch: {
    chapter_end_id(val) {
        	// if the End Chapter ID is not null, open the timeshift modal
	        if (val !== null) {
        this.$refs.timeshiftModal.open();
      }
    },
  },
  data() {
    return {
      isLoading: false,

      chapter_start_id: null,
      chapter_end_id: null,
      entry_start_id: null,
      entry_end_id: null,

      mode: 'addition',
      secondsToAdjust: 0,
      sliderValue: 0,
    };
  },
  computed: {
	    isStartPointChapter() {
		    return this.chapter_start_id !== null && this.entry_start_id === null;
	    },
	    isEndPointChapter() {
		    return this.chapter_end_id !== null && this.entry_end_id === null;
	    },
	    isStartPointEntry() {
		    return this.entry_start_id !== null && this.chapter_start_id !== null;
	    },
	    isEndPointEntry() {
		    return this.entry_end_id !== null && this.chapter_end_id !== null;
	    },
	    isStartPointSelected() {
		    return this.isStartPointChapter || this.isStartPointEntry;
	    },
	    isEndPointSelected() {
		    return this.isEndPointChapter || this.isEndPointEntry;
	    },


    /*
      * Returns the timestamp of the Start Element.
      */
    getSecondsOfFirstSelectedElement() {
      if (this.entry_start_id !== null) {
        return this.getEntryById(this.entry_start_id, this.chapter_start_id).timestamp;
      } if (this.chapter_start_id !== null) {
        return this.getChapterById(this.chapter_start_id).timestamp;
      }
      return null;
    },

    /**
       * Returns the amount of seconds that should be added / removed from the existing timestamp.
       */
    getSecondsToRemoveOrAdd() {
      const value = (parseInt(this.secondsToAdjust) + parseInt(this.sliderValue));

      return value;
    },

    /**
       * Returns the new Timestamp that the Start Element will have with the currently selected modifiers.
       */
    getSecondOutcomeForFirstElement() {
      const oldSecs = this.getSecondsOfFirstSelectedElement;
      if (oldSecs === null) { return 0; }

      if (this.mode === 'subtract') {
        const calc = oldSecs - this.getSecondsToRemoveOrAdd;

        return calc < 0 ? 0 : calc;
      }
      return oldSecs + this.getSecondsToRemoveOrAdd;
    },

    /**
       * Returns a list of chapters that should be highlighted based on the current selection.
       */
    getChaptersToHighlight() {
      return this.getChaptersBetween(this.chapter_start_id, this.chapter_end_id)
        .map(chapter => chapter.id);
    },
    /**
       * Returns a list of entries that should be highlighted based on the current selection.
       */
    getEntriesToHighlight() {
      return this.getEntriesBetween(this.chapter_start_id, this.entry_start_id, this.chapter_end_id, this.entry_end_id)
        .map(entry => entry.id);
    },

    /**
       * Determines whether the user is able to save its selection and execute a timeshift.
       */
    canLaunchTimeshift() {
      return (this.chapter_start_id !== null && this.chapter_end_id !== null)
          && (this.getSecondsOfFirstSelectedElement !== this.getSecondOutcomeForFirstElement);
    },
  },
  methods: {
    /**
       * Set all Values to their default.
       */
    setDefaults() {
      this.chapter_start_id = null;
      this.chapter_end_id = null;
      this.entry_start_id = null;
      this.entry_end_id = null;
      this.mode = 'addition';
      this.secondsToAdjust = 0;
      this.sliderValue = 0;
    },

    /**
       * Executes the timeshift.
       */
    async executeTimeshift() {
      if (!this.canLaunchTimeshift) { return false; }

      let removeOrAdd = 0;
      if (this.mode === 'subtract') { removeOrAdd = -this.getSecondsToRemoveOrAdd; } else removeOrAdd = this.getSecondsToRemoveOrAdd;

      return await ChapterRepository.timeShift(removeOrAdd, this.chapter_start_id, this.chapter_end_id, this.entry_start_id, this.entry_end_id).then((res) => {
        InstanceRepository.refetchActive(false);
        this.$refs.timeshiftModal.close();
      });
    },

    /**
       * This function registers once a chapter is clicked.
       */
    clickOnChapter(chapter) {
      /**
         * ======================================
         * CURRENT CHAPTER ALREADY SELECTED
         * ======================================
         */

      // If the clicked Chapter was the Start
      if (this.chapter_start_id === chapter.id) {
      	// The Same Chapter was clicked twice
      	if (this.chapter_end_id === null) {
		      this.chapter_end_id = chapter.id;
        }

        // this.chapter_start_id = null;
        // this.chapter_end_id = null;
        // this.entry_end_id = null;
        return true;
      }

      // if the clicked Chapter was the End
      if (this.chapter_end_id === chapter.id) {
        this.chapter_end_id = null;
        return true;
      }

      /**
         * ================================
         * CURRENT CHAPTER WAS NOT SELECTED
         * ================================
         */
      if (this.chapter_start_id !== null) {
        if (this.getChapterById(this.chapter_start_id).order > chapter.order) { return false; }
      }

      // First Selection
      if (this.chapter_start_id === null) {
        this.chapter_start_id = chapter.id;
        return true;
      } if (this.chapter_end_id === null) {
        this.chapter_end_id = chapter.id;
      }
    },

    /**
       * This function registers once an entry is clicked.
       */
    clickOnEntry(chapter, entry) {
      /**
         * ======================================
         * CURRENT ENTRY ALREADY SELECTED
         * ======================================
         */

      // If the clicked Entry was the Start
      if (this.entry_start_id === entry.id) {
      	// When the end is not set, but the clicked entry is the same as the start
        // => Only 1 Entry selected.
	      if (this.chapter_end_id === null) {
		      this.entry_end_id = entry.id;
		      this.chapter_end_id = chapter.id;
		      return true;
	      }
		      this.entry_start_id = null;
		      this.entry_end_id = null;
		      this.chapter_start_id = null;
		      this.chapter_end_id = null;
		      return true;
      }

      // if the clicked Entry was the End
      if (this.entry_end_id === entry.id) {
        this.entry_end_id = null;
        this.chapter_end_id = null;
        return true;
      }

      /**
         * ================================
         * CURRENT ENTRY WAS NOT SELECTED
         * ================================
         */
      // First Selection
      if (this.entry_start_id === null) {
        // if a chapter is selected as the start
        if (this.chapter_start_id !== null) {
          this.entry_end_id = entry.id;
          this.chapter_end_id = entry.chapterid;
        } else {
          this.chapter_start_id = entry.chapterid;
          this.entry_start_id = entry.id;
        }
        return true;
      } if (this.entry_end_id === null) {
        this.entry_end_id = entry.id;
        this.chapter_end_id = entry.chapterid;
      }
    },

    /**
       * Returns a chapter based on its id.
       *
       * @param id
       * @returns {*}
       */
    getChapterById(id) {
      return this.chapters.find(chapter => chapter.id === id);
    },

    /**
       * Returns all entries of the specified chapter.
       *
       * @param chapterId
       * @returns {*}
       */
    getEntriesOfChapter(chapterId) {
      return this.getChapterById(chapterId).entries;
    },

	    /**
	     * Returns the last entry of a chapter (= Highest `order`)
	     *
	     * @param chapterId
	     * @returns {*}
	     */
	    getLastEntryOfChapter(chapterId) {
		    return this.getEntriesOfChapter(chapterId).slice().sort((a, b) => a.order - b.order).pop();
	    },

	    /**
	     * Returns the first entry of a chapter (= Lowest `order`)
	     *
	     * @param chapterId
	     * @returns {*}
	     */
	    getFirstEntryOfChapter(chapterId) {
		    return this.getEntriesOfChapter(chapterId).slice().sort((a, b) => a.order - b.order).shift();
	    },

    /**
       * Returns all Entries of the given chapter that have an higher order than the given entry.
       *
       * @param entryId
       * @param chapterId
       * @returns {*}
       */
    getEntriesWithHigherOrder(entryId) {
      const givenEntry = this.getEntryById(entryId);
      const highestEntryOrderInChapter = this.getLastEntryOfChapter(givenEntry.chapterid);

      return this.getEntriesOfChapter(givenEntry.chapterid)
        .filter(entry => entry.order >= givenEntry.order && entry.order <= highestEntryOrderInChapter.order);
    },

	    /**
	     * Returns all Entries of the given chapter that have a lower or equal order than the given entry.
	     *
	     * @param entryId
	     * @returns {*}
	     */
	    getEntriesWithLowerOrder(entryId) {
		    const givenEntry = this.getEntryById(entryId);

		    return this.getEntriesOfChapter(givenEntry.chapterid)
        .filter(entry => entry.order <= givenEntry.order && entry.order >= 0);
	    },

    /**
       * Returns all chapters that are listed between the two given chapters.
       * This is useful to highlight them in the list.
       *
       * @returns {Array|*[]|*}
       * @param startChapterId
       * @param endChapterId
       */
    getChaptersBetween(startChapterId = null, endChapterId = null) {
      	const chaptersToHighlight = [];

      	// Starting Point Selected
      	if (this.isStartPointSelected) {
      		// Start Point is a chapter, so highlight that one
		      if (this.isStartPointChapter) {
			      chaptersToHighlight.push(this.getChapterById(startChapterId));
        }

		      // End Point is Selected
		      if (this.isEndPointSelected) {
		      	// if Both Start & End Points are Entries of the same chapter, dont select anything
          if (this.isStartPointEntry && this.isEndPointEntry) {
            	const startEntry = this.getEntryById(this.entry_start_id);
            	const endEntry = this.getEntryById(this.entry_end_id);

            	if (this.selectedEntriesInSameChapter(startEntry, endEntry)) {
            		return [];
	            }
          }

		      	// Get all Chapters between Start & End
          const startChapter = this.getChapterById(startChapterId);
          const endChapter = this.getChapterById(endChapterId);
          const toAdd = this.chapters.filter(chapter => chapter.order > startChapter.order && chapter.order <= endChapter.order);
			      chaptersToHighlight.push.apply(chaptersToHighlight, toAdd);

		      	// End Point is a chapter, so highlight that one.
          if (this.isEndPointChapter) {
	            chaptersToHighlight.push(this.getChapterById(endChapterId));
          }
        }
      }
	      return this.removeDuplicatesFromArray(chaptersToHighlight, 'id');
    },

    selectedEntriesInSameChapter(startEntry, endEntry) {
	    	return startEntry.chapterid === endEntry.chapterid;
    },

	    /**
	     * Returns all entries that are listed between the given entries and chapters.
	     * This is useful to highlight them in the list.
	     * {TODO: NOT WORKING}
	     *
	     * @param startChapterId
	     * @param startEntryId
	     * @param endChapterId
	     * @param endEntryId
	     */
	    getEntriesBetween(startChapterId = null, startEntryId = null, endChapterId = null, endEntryId = null) {
		    const entryOutput = [];

		    // If no Start point is selected, highlight nothing
		    if (!this.isStartPointSelected) { return []; }

		    // If the Start point is a chapter, but there is no end point:
      // => No Entry should be selected
		    if (this.isStartPointChapter && !this.isEndPointSelected) {
		    	return [];
      }

		    // No End Point is Selected
		    // However if the start point is an entry, highlight it.
		    if (!this.isEndPointSelected) {
			    if (this.isStartPointEntry) {
				    return [this.getEntryById(startEntryId)];
			    }
		    }

		    // Both Points are Entries & in the same Chapter
		    if (this.isStartPointEntry && this.isEndPointEntry) {
			    const firstEntry = this.getEntryById(startEntryId);
			    const secondEntry = this.getEntryById(endEntryId);

			    if (this.selectedEntriesInSameChapter(firstEntry, secondEntry)) {
				    const chapter = this.getChapterById(firstEntry.chapterid);
				    const entrylist = this.getEntriesBetweenInChapter(chapter, firstEntry, secondEntry);
				    entryOutput.push.apply(entryOutput, entrylist);
				    return entryOutput;
			    }
		    }

		    /**
		     * The Start & End Chapter are different
		     */

		    if (this.isStartPointChapter) {
			    // The Start is a Chapter. So all Entries in the chapter will be highlighted, unless the endpoint is the same chapter
        if (this.isEndPointChapter) {
          	if (startChapterId !== endChapterId) {
		          entryOutput.push.apply(entryOutput, this.getChapterById(startChapterId).entries);
          }
			    }
		    } else if (this.isStartPointEntry) {
			    // The Start is an Entry. So all Entries that come after the entry in the same chapter will be highlighted.
			    const startEntry = this.getEntryById(startEntryId);
			    entryOutput.push.apply(entryOutput, this.getEntriesWithHigherOrder(startEntry.id));
		    }

		    // Between Chapters: Highlight All Entries of every chapter in between
      const betweenChapters = this.getChaptersBetween(startChapterId, endChapterId);
		    // Remove last Chapter
		    betweenChapters.pop();

		    betweenChapters.forEach((betweenChapter) => {
		    	// Dont Highlight all the entries of the first chapter if the start point is a entry
        if (this.isStartPointEntry) {
	          if (betweenChapter.id !== startChapterId) { entryOutput.push.apply(entryOutput, betweenChapter.entries); }
        } else {
	          entryOutput.push.apply(entryOutput, betweenChapter.entries);
        }
      });

      if (this.isEndPointChapter) {
        	// End point is chapter, no entries will be added
      } else if (this.isEndPointEntry) {
        	// End Point is entry. Add all entries that come before.

	        entryOutput.push.apply(entryOutput, this.getEntriesWithLowerOrder(endEntryId));
      }

		    return this.removeDuplicatesFromArray(entryOutput, 'id');
	    },


    /**
       * Fetches an Entry by its ID.
       * */
    getEntryById(entryId) {
	    	return this.chapters.flatMap(chapter => chapter.entries).filter(entry => entry.id === entryId).shift();
    },

    /**
       * Returns all Entries between two entries inside of a chapter
       * */
    getEntriesBetweenInChapter(chapter, firstEntry, secondEntry) {
	      return chapter.entries.filter(entry => entry.order >= firstEntry.order && entry.order <= secondEntry.order);
    },

    /**
       * Transforms the given seconds into a string with the format HH:mm:ss
       *
       * @param seconds
       * @returns {*}
       */
    secondsToTimestamp(seconds) {
      return this.$moment().startOf('day').seconds(seconds).format('HH:mm:ss');
    },

    /**
       * Returns the background color class for the given entry
       *
       * @param entry
       * @param chapter
       * @returns {string}
       */
    getEntryClass(entry) {
	      if (this.getEntriesToHighlight.includes(entry.id)) { return 'bg-dark text-white'; }

	      return entry.order % 2 ? 'entry-grey' : '';
    },


	    /**
       * Removes duplicate objects from an array.
       *
	     * @param originalArray
	     * @param prop
	     * @returns {[]}
	     */
	    removeDuplicatesFromArray(originalArray, prop) {
		    const newArray = [];
		    const lookupObject = {};

		    for (var i in originalArray) {
			    lookupObject[originalArray[i][prop]] = originalArray[i];
		    }

		    for (i in lookupObject) {
			    newArray.push(lookupObject[i]);
		    }
		    return newArray;
	    },
  },
};
</script>
